import { Box, Group, Text } from '@mantine/core';

import Chip from '@/components/Chip';

import type { EligibleMealPeriods } from '../types';
import { MealPeriod } from '../types';
import { MEAL_PERIOD_LABELS, MEAL_PERIODS } from '../constants';

type MealPeriodsProps = {
  selectedPeriods: Set<MealPeriod>;
  eligiblePeriods: EligibleMealPeriods | null;
  onToggle: (period: MealPeriod) => void;
  disabled: boolean;
};

const MealPeriodsSelector: React.FC<MealPeriodsProps> = ({
  selectedPeriods,
  eligiblePeriods,
  onToggle,
  disabled,
}) => (
  <Box>
    <Text fw={600} fz="md" c="black">
      Meal periods
    </Text>
    <Text c="dimmed" mt={2} mb="xs" fz="xs">
      Select all meal periods you can support for Popup
    </Text>
    <Group gap="xs">
      {MEAL_PERIODS.filter((period) => eligiblePeriods?.[period]).map((period) => {
        const isDisabled = disabled;
        const isSelected = selectedPeriods.has(period);

        return (
          <Chip
            key={period}
            checked={isSelected}
            onChange={() => onToggle(period)}
            disabled={isDisabled}
            color="blue"
            variant={isSelected ? 'light' : 'outline'}
          >
            {MEAL_PERIOD_LABELS[period]}
          </Chip>
        );
      })}
    </Group>
  </Box>
);

export default MealPeriodsSelector;
